export default __webpack_public_path__ + "static/media/middle.42d1566a.svg";